import { Outlet, Link } from 'react-router-dom';

import { buttonVariants } from '@/components/ui/button';

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:p-2 focus:bg-white focus:text-black focus:shadow-lg"
      >
        Skip to main content
      </a>

      {/* Header */}
      <header className="border-b bg-white">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="/brand/logo-color.png" alt="Academics in Action" className="h-10" />
          </Link>

          <nav className="flex items-center gap-4">
            <Link to="/login" className={buttonVariants({ variant: 'ghost' })}>
              Log In
            </Link>
            <a
              href="https://www.academicsinaction.org/pilotpulse"
              target="_blank"
              rel="noopener noreferrer"
              className={buttonVariants()}
            >
              Learn More
            </a>
          </nav>
        </div>
      </header>

      {/* Main content */}
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-aia-navy text-white py-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="font-semibold text-lg mb-4">PilotPulse</h3>
              <p className="text-sm text-gray-300">
                Helping CTE instructors and administrators track implementation pilots and transform
                student outcomes.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Resources</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li>
                  <a href="/guide" className="hover:text-white">
                    Getting Started Guide
                  </a>
                </li>
                <li>
                  <a href="/guide" className="hover:text-white">
                    Documentation
                  </a>
                </li>
                <li>
                  <a href="mailto:support@academicsinaction.org" className="hover:text-white">
                    Contact Support
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li>
                  <a href="https://academicsinaction.org" className="hover:text-white">
                    Academics in Action
                  </a>
                </li>
                <li>
                  <a href="https://academicsinaction.org/privacy" className="hover:text-white">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="https://academicsinaction.org/terms" className="hover:text-white">
                    Terms of Service
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-gray-700 text-center text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Academics in Action LLC. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}
